// extracted by mini-css-extract-plugin
export var image = "HowToMeasurePeople-module--image--75614";
export var item = "HowToMeasurePeople-module--item--da681";
export var list = "HowToMeasurePeople-module--list--3cba1";